import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getVehicleRequest, setVehicle } from '../../../../../../../vehicles/actions/vehicles';
import { vehiclesSelector } from '../../../../../../../vehicles/selectors/vehicles';

import Vehicle from './Vehicle';

const mapStateToProps = createStructuredSelector({
    vehicles: vehiclesSelector
});

const mapDispatchToProps = {
    getVehicleRequest,
    setVehicle
};

export default connect(mapStateToProps, mapDispatchToProps)(Vehicle);